<template>
  <form class="auth-login-form" @submit.prevent="handleSubmit">
    <BaseInput
      class="mb-3"
      type="email"
      size="xl"
      id="loginEmail"
      placeholder="E-mail"
      v-model="$v.user.email.$model"
      :error="$v.user.email.$error"
      :message="emailErrorMessages"
    />

    <BaseInput
      class="mb-3"
      type="password"
      size="xl"
      id="loginPassword"
      placeholder="Senha"
      v-model="$v.user.password.$model"
      :error="$v.user.password.$error"
      :message="passwordErrorMessages"
      show-password-toggle
    />

    <BaseButton
      class="mt-3"
      type="submit"
      size="xl"
      block
      :disabled="$v.user.$invalid || isSubmitting"
    >
      <span class="mr-2">Entrar</span>
      <BaseSpinner v-if="isSubmitting" variant="light" size="sm" />
    </BaseButton>

    <BaseButton
      class="mt-2"
      type="button"
      variant="primary"
      outline
      size="xl"
      block
      :disabled="$v.user.$invalid || isSubmitting"
      @click.native="loginAsClinic"
    >
      Entrar como Clínica
    </BaseButton>

    <p class="auth-text auth-form-forgot-password">
      Esqueceu a senha?
      <a href="/recuperarSenha">Recuperar</a>
    </p>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import { isDoctor } from "../utils/userRole";

export default {
  name: "LoginForm",
  data() {
    return {
      user: {
        email: "",
        password: ""
      },
      redirectFrom: ""
    };
  },
  validations: {
    user: {
      email: { required, email },
      password: { required }
    }
  },
  mounted() {
    this.redirectFrom = this.$route.query.redirectFrom;
  },
  methods: {
    ...mapActions("auth", ["login"]),

    async handleSubmit() {
      this.login({ ...this.user, redirectFrom: this.redirectFrom })
        .then(path => {
          this.$router.push({ path });
        })
        .catch(error => error);
    },
    // Entrada pela Clínica: autentica e, se o usuário for staff (membership via
    // /clinica/session), vai direto ao /clinica; senão, avisa que não tem acesso.
    async loginAsClinic() {
      this.$v.user.$touch();
      if (this.$v.user.$invalid) return;

      try {
        await this.login({ ...this.user, redirectFrom: this.redirectFrom });
      } catch (error) {
        return; // credenciais inválidas — o form já mostra o erro
      }

      try {
        await this.$store.dispatch("clinica/init");
      } catch (error) {
        // sessão da clínica falhou → tratado como não-staff abaixo
      }

      if (this.$store.getters["clinica/isStaff"]) {
        this.$router.push({ name: "ClinicDashboard" });
      } else {
        this.$toast.error("Este usuário não tem acesso à Clínica.");
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["isSubmitting", "redirectPathName"]),
    ...mapGetters("user", ["getCurrentUser"]),

    emailErrorMessages() {
      let errors = [];
      !this.$v.user.email.required && errors.push("E-mail é obrigatório");
      !this.$v.user.email.email && errors.push("E-mail é inválido");
      return errors;
    },
    passwordErrorMessages() {
      let errors = [];
      !this.$v.user.password.required && errors.push("Senha é obrigatória");
      return errors;
    },
    isDoctor() {
      return isDoctor(this.getCurrentUser);
    }
  }
};
</script>
